var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-number-input text-input",class:{
    disabled: _vm.disabled
  }},[_c('input',{staticClass:"h-empty-input h-monrope",attrs:{"placeholder":_vm.placeholder,"required":_vm.required,"min":_vm.min,"max":_vm.max,"disabled":_vm.disabled,"type":"number","readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus}})])
}
var staticRenderFns = []

export { render, staticRenderFns }